export enum TimelineEventSource {
  /**
   * Changed by user interaction events.
   */
  User = 'user',
  /**
   * Changed programmatically.
   */
  Programmatically = 'programmatically',
  SetTimeMethod = 'setTimeMethod',
}
